module.exports = __webpack_public_path__ + "static/media/08_hero_desktop.d15f70ca.jpg";